import React from 'react';
import { formatDateTime, getRelativeTime } from '../utils/dateTime';

interface RelativeTimeProps {
    value: string | null | undefined;
    // Text for a missing timestamp.
    empty?: string;
}

// Relative time in the cell, exact local time in the tooltip.
const RelativeTime: React.FC<RelativeTimeProps> = ({ value, empty = '—' }) => {
    if (!value) return <>{empty}</>;
    return (
        <span className="cursor-default" title={formatDateTime(value)}>
            {getRelativeTime(value)}
        </span>
    );
};

export default RelativeTime;
